import {useAppSelector} from "../../../../../../../redux/hooks";
import {
  getDoesMySongsLibraryUserLibraryIncludeLessonId
} from "../../../../../modules/my-songs-library-store/mySongsLibrary.selector";

export interface IWhenLessonInUserLibraryLogic {
  isLessonInUserLibrary: boolean;
}

export const useWhenLessonInUserLibraryLogic = (lessonId: number): IWhenLessonInUserLibraryLogic => {
  const isLessonInUserLibrary = useAppSelector(() => getDoesMySongsLibraryUserLibraryIncludeLessonId(lessonId));

  return {
    isLessonInUserLibrary,
  };
}
